import { appearanceMap } from '../../../../../../common/constants.tsx';
import type { JiraStatusCategoryColor } from './__generated__/getCommonPropsQuery.graphql';

type ColorName = keyof typeof appearanceMap;
type Appearance = (typeof appearanceMap)[ColorName];

export const getLozengeAppearance = (
	colorName: JiraStatusCategoryColor | null | undefined,
): Appearance | undefined => {
	// eslint-disable-next-line @typescript-eslint/consistent-type-assertions
	if (colorName && Object.keys(appearanceMap).includes(colorName as ColorName)) {
		// eslint-disable-next-line @typescript-eslint/consistent-type-assertions
		return appearanceMap[colorName as ColorName];
	}

	return undefined;
};
